<ng-container *ngIf="worksheets$ | async as worksheets; else loadingRef">
  <ng-container *ngIf="isGalleryPage">
    <ng-container *ngFor="let worksheetGroup of worksheets">
      <div *ngIf="firstVideoItem" class="py-lg-4 pb-3 bg-primary">
        <div class="container d-lg-flex gap-4">
          <div class="first-video-container col-12 col-lg-8">
            <ng-container #outlet [ngTemplateOutlet]="content"></ng-container>
            <ng-template #content>
              <fgb-worksheet-item
                [worksheetItem]="firstVideoItem"
                [worksheetId]="worksheetGroup.WorksheetId"
                [isPlaying]="isPlaying"
              ></fgb-worksheet-item>
              <h4 class="text-white font-size-18 mt-3 mb-1 text-capitalize">{{ firstVideoItem.Title }}</h4>
              <p class="text-white font-size-14 mb-0">{{ firstVideoItem.Description }}</p>
            </ng-template>
          </div>
          <div class="other-video-container col-4 d-none d-lg-flex flex-column gap-5 pe-1">
            <ng-container *ngFor="let item of listVideos">
              <div class="video-container" [class.active]="item.Id === firstVideoItem.Id">
                <div class="thumbnail position-relative">
                  <img [src]="item.Image | contentImage : '1'" alt="" />
                </div>
                <div class="playing-overlay">
                  <span class="">{{ 'worksheet.now.playing.text' | translate }}</span>
                </div>
                <div class="play-button-container" (click)="handleClickPlay(item)">
                </div>
                <p class="text-white font-size-14 mb-0 mt-2 fw-bold">{{ item.Title }}</p>
              </div>
            </ng-container>
          </div>
          <div class="d-lg-none">
            <owl-carousel-o [options]="customOptions">
              <ng-container *ngFor="let item of listVideos">
                <ng-template [width]="171" carouselSlide>
                  <div>
                    <div class="video-container" [class.active]="item.Id === firstVideoItem.Id">
                      <div class="thumbnail position-relative">
                        <img [src]="item.Image | contentImage : '1'" alt="" />
                      </div>
                      <div class="playing-overlay">
                        <span class="">{{ 'worksheet.now.playing.text' | translate }}</span>
                      </div>
                      <div class="play-button-container" (click)="handleClickPlay(item)">
                      </div>
                    </div>
                    <p class="text-white font-size-14 mt-2">{{ item.Title }}</p>
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </div>
      </div>
      <div class="container text-center">
        <div>
          <h2
            *ngIf="worksheetGroup.Items && hasWorksheetType(worksheetGroup.Items, worksheetType.Gallery)"
            class="font-size-18 text-start text-white header-title text-uppercase my-3"
          >
            {{ 'gallery.content.title' | translate }}
          </h2>
          <div class="row row-gap-20">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Gallery">
                <div class="{{ colOverride }}" [ngClass]="isList && !colOverride ? 'col-lg-4 col-6' : ''">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isWorksheetPage">
    <ng-container *ngFor="let worksheetGroup of worksheets">
      <div class="container text-center mt-lg-4">
        <div>
          <!-- <h2 class="font-size-18 text-start download-title text-capitalize text-white mt-0 pt-4">{{ 'downloads.title' | translate }}</h2> -->
          <div class="row row-gap-20">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Download">
                <div class="{{ colOverride }}" [ngClass]="isList && !colOverride ? 'col-lg-4 col-12' : ''">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="isOffers && worksheets[0]">
    <div class="container text-center mt-4 offers-container">
      <h2 class="text-start pb-2 text-black suboffers-heading text-uppercase">
        {{ 'home.page.offers.subheading' | translate }}
      </h2>
      <owl-carousel-o [options]="offerCustomOptions">
        <ng-container *ngFor="let item of worksheets[0].Items">
          <ng-container *ngIf="item.WorksheetType == worksheetType.Link">
            <ng-template carouselSlide>
              <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="item.WorksheetId"></fgb-worksheet-item>
            </ng-template>
          </ng-container>
        </ng-container>
      </owl-carousel-o>
    </div>
  </ng-container>
</ng-container>

<!-- Loading -->
<ng-template #loadingRef>
  <div class="w-100">
    <fgb-loading></fgb-loading>
  </div>
</ng-template>
